<template>
    <div class="cg-head" >
       	<span @click="goBack()" class="logo">
       		<img :src="isGlobal ? 'static/images/logo.png' : 'static/images/logo_cn.png'" alt="logo" />
       	</span>

        <span  class="selcountry" v-if="isGlobal" @click="toggleCountryMask">
        	<img v-if="conutry.src" :src="'static/images/country/'+conutry.src+'.png'" alt="country" />
          <span v-else>{{ conutry.content }}</span>
        </span>

        <div class="mask country"  v-show="countryis" @click.stop="countryis = false">
            <transition name="countryback" >
              <div class="countryback" v-show="countryis">
                  <div v-for="(item,index) in dict" :keys="index">
                      <div v-if="item.sty == 'title'" class="countrytitle">{{item.content}}</div>
                      <div v-else class="countryitem" @click="changeconutry(item)"><p>{{item.content}}</p><img v-if="item.src" :src="'static/images/country/'+item.src+'.png'" /></div>
                  </div>
                  <div style="height: 1.25rem;width: 100%;"></div>
              </div>

            </transition>
        </div>
    </div>
</template>

<script>
  import { mapGetters,mutations } from 'vuex';
  import conutryarr from './country.js'
  export default {
    computed: {
      ...mapGetters([
        'conutry',
        'isGlobal'
      ]),
    },
    data() {
       return {
            countryis:false,
            dict:[]
       }
    },
    created(){
      this.dict =conutryarr;
    },
    mounted() {

    },
    methods:{
      toggleCountryMask() {
        this.countryis = !this.countryis
      },
      changeconutry(item){
        this.$store.commit('SET_COUNTRY',item);
        this.countryis = false;
      },
      goBack(){
        window.scrollTo(0,0);
        if(this.$route.path!='/'){
          this.$router.push({path:'/'});
        }
      },
    },

  }
</script>

<style scoped>
  .cg-head{
  	width: 100%;
  	position: fixed;
  	background-color: #FFFFFF;
  	top: 0;
  	left: 0;
    height: 3.125rem;
    z-index: 100;
    box-shadow: 0px 0px 1rem 0px rgba(32, 41, 55, 0.63);
  }
  .cg-head header{
  	width: 100%;
  	margin: 0 auto;

  }
  .logo img{
  	height: 1.875rem;
  	width: auto;
    margin-left: 0.625rem;
    margin-top: 0.625rem;
  	float: left;
    cursor: pointer;
  }
  .selcountry{
    position: absolute;
    right: 0.625rem;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .selcountry img{
    height:1.5rem;
    border: 1px solid #ccc;

  }
  .country{
    top: 3.125rem;
    height: calc(100% - 3.125rem);
  }

  .countrytitle{
    margin: 1.25rem  0.9375rem 0;
    color: #FFFFFF;
    font-size: 1.25rem;
    font-family: "Regular";
    padding-bottom: 0.625rem;
    border-bottom: 1px solid #3E475E;
  }
  .countryitem{
    margin: 1.25rem  0.9375rem 0;
    display: flex;
    justify-content: space-between;
  }
  .countryitem p{
    height: 1.5rem;
    font-size: 1rem;
    color: #A9ADB0;
    line-height: 1.5rem;
  }
  .countryitem img{
    display: block;
    height:1.5rem;
    width:2.3rem ;
  }

  .countryback{
    width:72%;
    overflow-y: auto;
    position: absolute;
    top: 0;
    right: 0;
    background-color: #293549;
    height:100%;
  }

  .countryback-enter-active, .countryback-leave-active {
    transition: all .5s;
  }
  .countryback-enter, .countryback-leave-to /* .fade-leave-active below version 2.1.8 */ {
    right: -72%;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/head.vue